
























































































































import { Vue, Component, Prop, PropSync, Watch, Emit, Inject } from 'vue-property-decorator';
import Hangul from 'hangul-js';

type StringMap = { [key: string]: string };

interface State {
  group?: object;
  item?: object;
  itemIdx: number;
  prevGroup: number;
  prevItem: number;
  searchText: string;
}

@Component
export default class AListPanel extends Vue {
  state: State = {
    itemIdx: 0,
    prevGroup: 0,
    prevItem: 0,
    searchText: ''
  };

  current = {
    item: -1
  };

  @Inject()
  getLoading!: () => boolean;

  async sleep(ms: number) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }

  @Prop({ type: String, default: '이름없는 리스트' })
  title!: string;

  @Prop({ type: Boolean, default: false })
  hideGroup!: boolean;

  @Prop({ type: Array, default: () => [] })
  groups!: StringMap[];

  @Watch('groups', { deep: true })
  groupsChanged() {
    if (this.groups.length > 0) {
      const idx = (this.groups[0][this.groupValue] as unknown) as number;
      const current = this.groups.find(x => ((x[this.groupValue] as unknown) as number) === idx);

      this.$group = idx;
      this.$item = -1;
      this.$emit('group', current);
    }
  }

  @Prop({ type: String, default: 'name' })
  groupText!: string;

  @Prop({ type: String, default: 'value' })
  groupValue!: string;

  @Prop({ type: Array, default: () => [] })
  items!: StringMap[];

  @Prop({ type: String, default: 'name' })
  itemText!: string;

  @Prop({ type: String, default: 'value' })
  itemValue!: string;

  @Prop({ type: String, default: null })
  itemSubText!: string;

  @Prop({ type: String, default: '' })
  groupHint!: string;

  @PropSync('group')
  $group!: number;

  @Watch('group')
  onGroupWatch(newVal: number) {
    this.$group = newVal;

    // 그룹이 바뀌면 item 선택을 해제한다
    this.$item = -1;

    const current = this.groups.find(x => ((x[this.groupValue] as unknown) as number) === newVal);
    this.$emit('group', current);
  }

  @PropSync('item', { type: Number })
  $item!: number;

  @Watch('$item')
  onItemWatch(newVal: number, oldVal: number) {
    // 현재 존재하는 아이템만 표시되도록 하기
    if (!this.items[this.$item]) {
      // 한번 더 클릭했을 때 선택해제 되지 않도록 하기
      if (this.$item === undefined) {
        if (this.items[0]) {
          this.$item = -1;

          setTimeout(() => {
            this.$item = oldVal;
            this.$emit('item', this.items[oldVal]);
          }, 0);
          return;
        }
      }

      // 없는 아이템이면 -1로 인덱스값 고정
      if (this.$item !== -1) {
        this.$item = -1;
        this.$emit('item', null);
      }
      return;
    }

    // item 이벤트 전파
    this.$emit('item', this.items[this.$item]);
  }

  add() {
    const current = this.groups.find(
      x => ((x[this.groupValue] as unknown) as number) === this.$group
    );
    this.$item = -1;
    this.$emit('add', current);
    return;
  }

  @Emit()
  search(value: string) {
    return value;
  }

  onGroupChanged(group: object[]) {
    this.state.group = group;
    this.$emit('group', group);
  }

  onItemChanged(item: object[]) {
    this.state.item = item;
    this.$emit('item', item);
  }

  get selectItem() {
    return this.current.item;
  }

  set selectItem(idx: number) {
    if (idx === undefined) {
      const current = this.current.item;
      setTimeout(() => (this.current.item = current), 0);
    }

    this.current.item = idx;
  }

  get searchItem() {
    return this.state.searchText;
  }

  set searchItem(text: string) {
    this.state.searchText = text;

    const item = this.items.findIndex(x => x === this.state.item);

    if (item === -1) {
      this.selectItem = -1;
    } else {
      this.selectItem = item;
    }
  }

  searchFilter(text: string) {
    if (!this.state.searchText.length) return true;

    const searcher = new Hangul.Searcher(this.state.searchText.trim());
    return searcher.search(text) !== -1;
  }
}
